import React from 'react';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const InformationCard = ({
    title,
    summary,
    details,
    expanded,
    onChange
}) => {

const cardStyle = {
    border: '1px solid #ccc',
    margin: '0px',
    padding: '0px',
    boxSizing: 'border-box',
    overflowY: 'auto'
};

    return (
        <Accordion expanded={expanded} onChange={onChange} style={cardStyle}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id="panel-header"
            >
                <Typography sx={{ fontFamily: 'Manrope, sans-serif', fontWeight: 'bold' }}>
                    {title}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div style={{ width: '100%' }}>
                    <Typography component="div" align="left" sx={{ fontFamily: 'Manrope, sans-serif' }}>
                        {summary}
                    </Typography>
                    <Typography component="div" align="left" sx={{ fontFamily: 'Manrope, sans-serif' }}>
                        {details}
                    </Typography>
                </div>
            </AccordionDetails>
        </Accordion>
    );
};

export default InformationCard;
